module.exports = __webpack_public_path__ + "img/Ignitemedialogo1.2960055c.png";